import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export interface Crumb {
  label: string;
  to?: string;
}

export function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav className="flex items-center gap-1 text-xs text-slate-500 mb-4" aria-label="Breadcrumb">
      {items.map((c, i) => {
        const last = i === items.length - 1;
        return (
          <span key={i} className="flex items-center gap-1">
            {c.to && !last ? (
              <Link
                to={c.to}
                className="hover:text-primary-600 transition-colors font-medium"
              >
                {c.label}
              </Link>
            ) : (
              <span className={last ? 'text-slate-700 font-semibold' : ''}>{c.label}</span>
            )}
            {!last && <ChevronRight className="h-3 w-3 text-slate-400" />}
          </span>
        );
      })}
    </nav>
  );
}
